import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import * as moment from 'moment';
import { first, filter } from 'rxjs/operators';
import { ValidatedResponse } from '../../shared/models/validated-response.model';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { IncidentModalComponent } from '../incident-modal.component';
import { Court } from '../models/court.model';
import { IncidentCustomer } from '../models/incident-customer.model';
import { JudgmentIncidentModel } from '../models/judgment-incident.model';
import { CourtService } from '../services/court.service';
import { IncidentTypeService } from '../services/incident-type.service';
import { IncidentService } from '../services/incident.service';
import { JudgmentIncidentService } from '../services/judgment-incident.service';
import { IncidentDialogContext } from '../shared/incident-dialog-context.model';
import { ProhibitionService } from '../../prohibition/services/prohibition.service';
import { EnumDataService } from '../services/enums.DataService';

@Component({
    templateUrl: './judgment-incident-modal.html'
})
export class JudgmentIncidentModalComponent extends IncidentModalComponent<JudgmentIncidentModel> {
    public courts: Court[];

    constructor(location: PlatformLocation,
        fb: UntypedFormBuilder,
        private service: JudgmentIncidentService,
        private courtService: CourtService,
        typeService: IncidentTypeService,
        public dialogRef: MatDialogRef<IncidentModalComponent<JudgmentIncidentModel>>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: IncidentDialogContext<JudgmentIncidentModel>,
        public incidentService: IncidentService,
        modalService: MvdModalService,
        prohibitionService: ProhibitionService,
        EnumDataService: EnumDataService
    ) {
        super(data, prohibitionService, fb, dialogRef, modalService, incidentService, EnumDataService, typeService, location);
    }

    protected onInit(form: any): void {
        // this.data.incident.customers.forEach(c => (<any>c).imageUrl = this.customerService.getPhotoUrl(c.id, c.legacySequenceNumber));
    }

    protected onLoadLookups(callback: (error?) => void): void {
        this.courtService.getAll().subscribe(r => this.onGetCourts(r.result, callback), callback);
    }

    private onGetCourts(result: Court[], callback: (error?) => void): void {

        this.courts = result;

        callback();
    }

    protected onLoadIncident(callback: (error?) => void): void {
        this.service.getIncident(this.data.incident.incidentNumberId).subscribe(r => this.onGetIncidentCompleted(r, callback), e => callback(e));
    }

    private onGetIncidentCompleted(incident: JudgmentIncidentModel, callback: (error?) => void): void {
        this.data.incident = incident;

        this.showUserInput = true;

        // Set accident date to have date type primeng likes
        this.data.incident.accidentDate = moment(this.data.incident.accidentDate).format('L');

        callback();
    }

    public async addCustomer(event: any): Promise<void> {

        if (this.data.incident.customers.some(i => i.id == event.customerNumber)) {
            return;
        }

        let result: ValidatedResponse<IncidentCustomer> = await this.incidentService.getCustomer(event.customerNumber).pipe(first()).toPromise();
        if (result && result.result) {
            let customer: IncidentCustomer = result.result;
            this.data.incident.customers.push(customer);
        }
    }

    public confirmRemoveCustomer(customer: IncidentCustomer) {
        let message = 'If you are sure you want to delete this customer from the abandoned vehicle fee incident record; press Delete again to complete the action.';
        this.modalService.confirm()
            .title('Delete Incident')
            .body(message)
            .okBtn('Delete')
            .cancelBtn('Cancel')
            .open()
            .afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(() => this.removeCustomer(customer));
    }

    public removeCustomer(customer: IncidentCustomer): void {
        let index: number = this.data.incident.customers.findIndex(v => v.id == customer.id);
        this.data.incident.customers.splice(index, 1);
    }

    protected onSaveIncident(callback: (error?: any) => void): void {

        // Get form values
        var court = this.incidentForm.get('courtId').value;
        this.data.incident.courtId = court.id;
        this.data.incident.accidentDate = this.incidentForm.get('accidentDate').value;
        this.data.incident.judgmentCreditor = this.incidentForm.get('judgmentCreditor').value;
        this.data.incident.attorneyName = this.incidentForm.get('attorneyName').value;
        this.data.incident.attorneyPhoneNumber = this.incidentForm.get('attorneyPhoneNumber').value;

        try {
            this.data.incident.otherCourtDetail = this.incidentForm.get('otherCourtDetail').value;
        } catch (e) {}

        this.service.saveIncident(this.data.incident).subscribe(r => { }, callback, callback);
    }

    protected onDeleteIncident(callback: () => void): void {
        this.service.deleteIncident(this.data.incident.incidentNumberId)
            .subscribe(_ => { }, e => this.handleError, () => {
                this.dialogRef.close(true);
            });
    }
}
